export default "__VITE_ASSET__Ut$VnLzN__"